"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANCELED = exports.REJECTED = exports.ACCEPTED = exports.ONGOING = exports.NONE = exports.PARTICIPANT = exports.MODERATOR = exports.OWNER = exports.WAS_CONNECTED = exports.NOT_CONNECTED = exports.CONNECTED = exports.CLOSING = exports.CLOSED = exports.OPENED = void 0;

/**
 * OPENED
 * @access protected
 * @type {string}
 */
var OPENED = 'OPENED';
/**
 * CLOSED
 * @access protected
 * @type {string}
 */

exports.OPENED = OPENED;
var CLOSED = 'CLOSED';
/**
 * CLOSING
 * @access protected
 * @type {string}
 */

exports.CLOSED = CLOSED;
var CLOSING = 'CLOSING';
/**
 * CONNECTED
 * @access protected
 * @type {string}
 */

exports.CLOSING = CLOSING;
var CONNECTED = 'CONNECTED';
/**
 * NOT_CONNECTED
 * @access protected
 * @type {string}
 */

exports.CONNECTED = CONNECTED;
var NOT_CONNECTED = 'NOT_CONNECTED';
/**
 * WAS_CONNECTED
 * @access protected
 * @type {string}
 */

exports.NOT_CONNECTED = NOT_CONNECTED;
var WAS_CONNECTED = 'WAS_CONNECTED';
/**
 * OWNER
 * @access protected
 * @type {string}
 */

exports.WAS_CONNECTED = WAS_CONNECTED;
var OWNER = 'OWNER';
/**
 * MODERATOR
 * @access protected
 * @type {string}
 */

exports.OWNER = OWNER;
var MODERATOR = 'MODERATOR';
/**
 * PARTICIPANT
 * @access protected
 * @type {string}
 */

exports.MODERATOR = MODERATOR;
var PARTICIPANT = 'PARTICIPANT';
/**
 * NONE
 * @access protected
 * @type {string}
 */

exports.PARTICIPANT = PARTICIPANT;
var NONE = 'NONE';
/**
 * Ongoing invitation
 * @access protected
 * @type {string}
 */

exports.NONE = NONE;
var ONGOING = 'ONGOING';
/**
 * Accepted invitation
 * @access protected
 * @type {string}
 */

exports.ONGOING = ONGOING;
var ACCEPTED = 'ACCEPTED';
/**
 * Rejected invitation
 * @access protected
 * @type {string}
 */

exports.ACCEPTED = ACCEPTED;
var REJECTED = 'REJECTED';
/**
 * Canceled invitation
 * @access protected
 * @type {string}
 */

exports.REJECTED = REJECTED;
var CANCELED = 'CANCELED';
exports.CANCELED = CANCELED;